// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"a9cc473a","71":"a9cc473a","124":"c363c25f","243":"c41d6a8f","297":"59f662da","412":"a9cc473a","566":"81f344d9","786":"c363c25f"}[chunkId] + ".chunk.css";
};